export default __webpack_public_path__ + "static/media/remoteslider.7820c5c2.mp4";